module.exports = __webpack_public_path__ + "media/images/kansai_recommended_guide_hero-91ab070ce26b2758935388b555454cd8.png";